import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslocoModule } from "@jsverse/transloco";

import { AssetLocationSelectionComponent } from "./components/asset-location-selection/asset-location-selection.component";
import { LorenBaseMapModule } from "../loren-base-map/loren-base-map.module";
import { LocationSelectionDialogComponent } from "./components/location-selection-dialog/location-selection-dialog.component";

@NgModule({
  declarations: [
    AssetLocationSelectionComponent,
    LocationSelectionDialogComponent,
  ],
  exports: [AssetLocationSelectionComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    FormsModule,
    LorenBaseMapModule,
    MatDialogModule,
    TranslocoModule,
  ],
})
export class LorenAssetLocationSelectionModule {}
